import { Injectable } from '@angular/core';

import { S3OptionsModel } from '../../../shared/controls/file-upload-control/typings/s3-options';

@Injectable({
  providedIn: 'root'
})
export class S3UploadService {

  upload ( file : File, options : S3OptionsModel ) : { request : XMLHttpRequest; fd : FormData } {
    const fd      = new FormData();
    const request = new XMLHttpRequest();

    fd.append('acl',                     options.acl);
    fd.append('Content-Type',            options['Content-Type']);
    fd.append('key',                     options.key);
    fd.append('policy',                  options.policy);
    fd.append('success_action_redirect', options.success_action_redirect);
    fd.append('x-amz-signature',         options.x_amz_signature);
    fd.append('x-amz-algorithm',         options['x-amz-algorithm']);
    fd.append('x-amz-credential',        options['x-amz-credential']);
    fd.append('x-amz-date',              options['x-amz-date']);
    fd.append('file',                    file);

    return { request, fd };
  }
}
